<template>
  <transition name="fade">
    <div class="tooltip" v-show="showTooltip">
      <span class="tooltipText"><span>{{text}}</span></span>
    </div>
  </transition>
</template>

<script type="text/ecmascript-6">
  export default{
    props: {
      text: {
        type: String
      }
    },
    data() {
      return {
        showTooltip: false
      };
    },
    methods: {
      show() {
        let th = this;
        this.showTooltip = true;
        /* eslint-disable no-unused-vars */
         let timer = setTimeout(function () {
         th.hide();
         }, 3000);
      },
      hide() {
        this.showTooltip = false;
      }
    }
  };
</script>

<style rel="stylesheet/stylus" lang="stylus">
  .tooltip
    position:fixed
    z-index:1000
    top:50%
    left:0
    width:100%
    margin-top:-24px
    text-align:center
    &.fade-enter-active,&.fade-leave-active
      transition:all 0.4s
    &.fade-enter,&.fade-leave-active
      opacity:0
    .tooltipText
      padding:6px 6px;
      background:#828282;
      border-radius:10px;
      display:inline-block;
      span
        padding:10px 12px;
        color:#fff;
        font-size:16px;
        background:#1c2023;
        border-radius:5px;
        display:inline-block;
</style>



// WEBPACK FOOTER //
// tooltip.vue?5a0443ee